import { useState, useEffect, useCallback } from 'react';
import { api, ProductSetup } from '@/lib/api';

export function useProductSetup(productId?: string | null) {
    const [setup, setSetup] = useState<ProductSetup | null>(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const fetchSetup = useCallback(async () => {
        if (!productId) return;
        
        setLoading(true);
        try {
            const data = await api.products.getSetup(productId);
            setSetup(data);
            setError(null);
        } catch (err: any) {
            console.error('Error fetching product setup:', err);
            setError(err.message || 'Failed to load setup progress');
        } finally {
            setLoading(false);
        }
    }, [productId]);

    useEffect(() => {
        if (!productId) {
            setSetup(null);
            return;
        }

        fetchSetup();
    }, [productId, fetchSetup]);

    return { setup, loading, error, refetch: fetchSetup };
}
